import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme"
export default class extends Controller {
  static targets = ["button", "darkIcon", "lightIcon"]

  connect() {
    this.initializeTheme()
  }

  initializeTheme() {
    const savedTheme = localStorage.getItem("color-theme")
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches

    if (savedTheme === "dark" || (!savedTheme && prefersDark)) {
      document.documentElement.classList.add("dark")
      this.showLightIcon()
    } else {
      document.documentElement.classList.remove("dark")
      this.showDarkIcon()
    }
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    localStorage.setItem("color-theme", isDark ? "dark" : "light")

    // Toggle icons
    this.darkIconTarget.classList.toggle("hidden")
    this.lightIconTarget.classList.toggle("hidden")
  }

  showDarkIcon() {
    this.darkIconTarget.classList.remove("hidden")
    this.lightIconTarget.classList.add("hidden")
  }

  showLightIcon() {
    this.lightIconTarget.classList.remove("hidden")
    this.darkIconTarget.classList.add("hidden")
  }
}
